import type { ComputedRef } from 'vue'

import { useCustomerStore } from '@entities/customer'
import { AppRoute } from '@shared/config'

import { useCustomerDestroy } from '../api/list/destroy.hook'

interface ModalCustomerDeleteReturn {
  refIsOpen: ComputedRef<boolean>
  refIsLoading: ComputedRef<boolean>
  closeModal: () => void
  confirmDelete: () => Promise<void>
}

/** Like the legacy page, a deleted customer leaves for the customers list. */
export const useModalCustomerDelete = (): ModalCustomerDeleteReturn => {
  const route = useRoute()
  const customerStore = useCustomerStore()

  const refIsOpen = computed<boolean>(() => customerStore.isModalDelete)
  const refIsLoading = computed<boolean>(() => customerStore.isProcessing)

  const closeModal = (): void => {
    if (customerStore.isProcessing) return

    customerStore.setModalDelete(false)
  }

  const confirmDelete = async (): Promise<void> => {
    if (customerStore.isProcessing) return

    customerStore.trackProcessing(true)
    const isDeleted = await useCustomerDestroy(Number(route.params.id))
    customerStore.trackProcessing(false)
    customerStore.setModalDelete(false)

    if (isDeleted) {
      customerStore.resetDetails()
      customerStore.resetCustomer()
      await navigateTo(AppRoute.Customers)
    }
  }

  return {
    refIsOpen,
    refIsLoading,
    closeModal,
    confirmDelete,
  }
}
